import AuthProvider from './lib/auth/provider'

const originalFetch = window.fetch

export default function (resource, options = {}) {
  const authenticator = AuthProvider.getAuthenticator()
  const newOptions = { ...options }

  if (!newOptions.headers) {
    newOptions.headers = {}
  }

  if (newOptions.headers instanceof Headers) {
    const headersObj = {}
    for (const [key, value] of newOptions.headers.entries()) {
      headersObj[key] = value
    }
    newOptions.headers = headersObj
  }

  newOptions.headers['Authorization'] = authenticator?.getToken()

  return originalFetch(resource, newOptions)
}
